// extracted by mini-css-extract-plugin
var _1 = "SingleImage-module__animateUploadProgressBarWidth--clqpV";
var _2 = "SingleImage-module__animatedBackground--UfwrO";
var _3 = "SingleImage-module__container--tZmwu";
var _4 = "SingleImage-module__image--QwRlu";
var _5 = "SingleImage-module__isFullSpan--u1sTs";
var _6 = "SingleImage-module__isHalfSpan--SOauj";
var _7 = "SingleImage-module__progress--l1vKt";
var _8 = "SingleImage-module__uploading--ZWxp3";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "image", _5 as "isFullSpan", _6 as "isHalfSpan", _7 as "progress", _8 as "uploading" }
